import "../style/home.css";
import mohammad from "../image/m7md.jpg";
import AboutMe from "../components/aboutMe/aboutMe";
import Content from "../components/content/content";
import Slider from "../components/sliderHome/slider";
import Certificate from "../components/certificate/certificate";
import { Link } from "react-router-dom";

export default function Home() {
  return (
    <>
      <div className="section1tr">
        <div className="hero">
          <div className="hero_container">
            <div className="hero_content">
              <div className="hero_constent_left">
                <div className="hero_content_left-title">
                  <p>Hello, I'm Mohammad</p>
                  <span className="span">Full Stack</span>
                </div>
                <div className="hero_content_left-text">
                  <p>
                    I am creating a question bank and summaries for university
                    subjects
                  </p>
                </div>
                <div className="hero_content_left-btn">
                  <Link to={"files"}>View My work</Link>
                </div>
                <div className="social">
                  <a href="https://www.linkedin.com/in/mohammed-al-bzoor-774b12329?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app">
                    <i className="fa-brands fa-linkedin" id="so" />
                  </a>
                  <a href="https://www.snapchat.com/add/m7md_bz?sender_web_id=a8230138-2cc3-4c8f-9e3a-b16e82757912&device_type=desktop&is_copy_url=true">
                    <i className="fa-brands fa-snapchat" id="so" />
                  </a>
                  <a href="https://www.instagram.com/cx.ili9/?utm_medium=copy_linkc">
                    <i className="fa-brands fa-instagram" id="so" />
                  </a>
                  <a href="https://www.youtube.com/@MohammadAlBzoor-2004/videos">
                    <i className="fa-brands fa-youtube" id="so" />
                  </a>
                </div>
              </div>

              <div className="hero_content_right">
                <img className="images" src={mohammad} alt="home" />
              </div>
            </div>
          </div>
          <div className="bg_img_box"></div>
        </div>
      </div>
      <div className="aboutMe">
        <AboutMe />
      </div>
      <div>
        <Certificate />
      </div>
      <div className="home_slider">
        {<Slider />}
      </div>
      <div>
        <Content className="home_slider" />
      </div>
    </>
  );
}